'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var IS_PRODUCTION = process.env.NODE_ENV === 'production';
exports.IS_PRODUCTION = IS_PRODUCTION;